export default __webpack_public_path__ + "de607d19a9b9421ab1a7c58c61e4a809.svg";